import React from 'react'
import styles from './CTASection.module.scss'
import { Text, TextName } from 'sdk'

interface CTASectionProps {
  logo: string
  logoAlt: string
  text: string
  backgroundImage: string
  className?: string
}

export const CTASection: React.FC<CTASectionProps> = ({
  logo,
  logoAlt,
  text,
  backgroundImage,
  className
}) => {
  return (
    <div
      className={`${styles.cta} ${className || ''}`}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className={styles.container}>
        <img src={logo} alt={logoAlt} className={styles.logo} />
        <Text type={TextName.Text}>
          {text}
        </Text>
      </div>
    </div>
  )
}